import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Paragraph from '../../Paragraph';
import Button from '../../Button';
import { renderField } from '../../Inputs';
import { Row } from '../../Register/Scaffold';
import Progress from '../../Progress';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');

const validate = (valueSet) => {
  const values = valueSet;
  const errors = { assessment: {} };

  if (!values.assessment) values.pregnant = {};
  if (!values.assessment.pregnant) errors.assessment.pregnant = 'Please select yes if you are pregnant';

  return errors;
};

class CurrentPregnant extends React.PureComponent {
  componentDidMount() {

  }

  render() {
    const { prevPage, handleSubmit } = this.props;

    return (
      <Row>
        <Progress step="activity" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
        </Paragraph>
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text" center><strong>Are you currently pregnant?</strong></Paragraph>
          <Field
            name="pregnant"
            type="radiogroup"
            params={{ dataKey: 'contact', name: 'pregnant' }}
            validate={[required]}
            component={renderField}
            centered
          />
          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={prevPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

CurrentPregnant.propTypes = {
  prevPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(CurrentPregnant);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/CurrentPregnant.jsx